<template>
  <h1 v-if="eventItem">
    <router-link :to="'/events/'+ eventItem.id">
      <i class="fas fa-long-arrow-alt-right"></i> {{ eventItem.title }}
    </router-link>
  </h1>

  <div id="events-list" class="container-fluid container-lg">
  
    <EventPage 
      v-if="eventsData && type == 'dinner'" 
      :pageItem="eventsData" />

    <div v-if="eventsData && type !== 'dinner'">
        <h2 v-if="pageTitle" class="text-center">
            {{ pageTitle }}
        </h2>

        <h3 v-if="pageSubTitle" class="text-center mt-3">
            {{ pageSubTitle }}
        </h3>

        <div v-if="sectionItem && sectionItem.text" v-html="sectionItem.text"></div>

        <hr v-if="sectionItem && sectionItem.text">

        <EventsListItem v-for="(item, index) in eventsData"
                        :key="index"
                        :event="item"
                        class="my-3" />
    </div>
    
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import EventPage from '../fairs/EventPage';
import EventsListItem from '../events/EventsListItem';

export default {
  name: 'EventsList',
  props: ['id', 'type', 'dayid', 'subpage'],
  computed: {
    ...mapGetters([
      'token',
      'eventsItems'
    ]),
    eventItem () {
      return this.$store.getters.fairItemFromId(Number(this.id));
		},
		sectionItem() {
			let eventsItem = this.eventItem.items.find(eventsItem => eventsItem.id === "events");
			//console.log('sectionItem', eventsItem)
			let sectionItem = eventsItem.items.find(sectionItem => sectionItem.id === this.type);
			return sectionItem;
		},
    eventsData() {
      if (!this.eventItem) return false;
      // pagina dinner => prelevo info pagina
      if (this.type == "dinner") {
        return this.sectionItem;
      }
      let returnItem = null;
      if (this.dayid) {
        // pagina daybyday => prelevo giorno selezionato
        returnItem = this.$store.getters.eventsItemsFromDate(this.id, this.dayid);
      } else {
				returnItem = this.$store.getters.eventsItemsFromType(this.id, this.type);
      }
			//console.log('dayid', this.dayid);
			//console.log('eventsData', returnItem);
      return returnItem;
    },
		pageTitle() {
			if (this.type == "daybyday") return 'Day by Day'
			let title = (this.sectionItem && this.sectionItem.title) ? this.sectionItem.title : null;
			return title;
		},
		pageSubTitle() {
			if (this.type !== "daybyday") return null
			let title = (this.eventsData.length > 0) ? this.eventsData[0].items[0].title : 'No event found';
			return title;
		}
  },
  components: {
    EventPage,
    EventsListItem
  }
}
</script>

<style>
</style>

<style scoped>
h3 {
  font-size: 20px;
  font-weight: 600;
}
</style>
